module.exports = __webpack_public_path__ + "img/volume-min.befadc48.svg";